<template>
  <div class="q-mt-md">
    <div v-if="discount.type === 'ticket'">
      <div class="text-h6 q-mb-sm">
        Matching Showings ({{ showings.loading ? '...' : filteredShowings.length }})
      </div>
      <div class="row">
        <q-inner-loading :showing="showings.loading" />
        <q-chip
          v-for="showing in filteredShowings.slice(0, 10)"
          :key="showing.id"
          :clickable="discount.isTranslation"
          class="col-auto"
          size="md"
          :label="showing.movie.name + ' - ' + showing.time"
          style="max-width: 300px;"
          :removable="!discount.isTranslation"
          @remove="exclude('siteShowings', showing); excludeId('siteShowing', showing.id)"
        >
          <q-menu
            bordered
            side="right"
            overlay
          >
            <q-list>
              <q-item
                v-close-popup
                :clickable="discount.isTranslation"
                @click.stop="include('siteMovies', showing.movie); includeId('siteMovie', showing.movie.id)"
              >
                <q-item-section avatar>
                  <q-icon name="filter_alt" />
                </q-item-section>
                <q-item-section>
                  Include Movie
                </q-item-section>
              </q-item>

              <q-item
                v-close-popup
                :clickable="discount.isTranslation"
                @click.stop="include('siteShowings', showing); includeId('siteShowing', showing.id)"
              >
                <q-item-section avatar>
                  <q-icon name="filter_alt" />
                </q-item-section>
                <q-item-section>
                  Include Showing
                </q-item-section>
              </q-item>

              <q-separator />

              <q-item
                v-close-popup
                :clickable="discount.isTranslation"
                @click.stop="exclude('siteMovies', showing.movie); excludeId('siteMovie', showing.movie.id)"
              >
                <q-item-section avatar>
                  <q-icon name="not_interested" />
                </q-item-section>
                <q-item-section>
                  Exclude Movie
                </q-item-section>
              </q-item>

              <q-item
                v-close-popup
                :clickable="discount.isTranslation"
                @click.stop="exclude('siteShowings', showing); excludeId('siteShowing', showing.id)"
              >
                <q-item-section avatar>
                  <q-icon name="not_interested" />
                </q-item-section>
                <q-item-section>
                  Exclude Showing
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-chip>
      </div>
    </div>
    <div v-else-if="discount.type === 'activity-ticket'">
      <div class="text-h6 q-mb-sm">
        Matching Activity Sessions ({{ activitySessions.loading ? '...' : filteredActivitySessions.length }})
      </div>
      <div class="row">
        <q-inner-loading :showing="activitySessions.loading" />
        <q-chip
          v-for="activitySession in filteredActivitySessions.slice(0, 10)"
          :key="activitySession.id"
          :clickable="discount.isTranslation"
          class="col-auto"
          size="md"
          :label="activitySession.activity.name + ' - ' + activitySession.siteStartTime"
          style="max-width: 300px;"
          :removable="!discount.isTranslation"
          @remove="exclude('siteActivitySessions', activitySession); excludeId('siteActivitySession', activitySession.id)"
        >
          <q-menu
            bordered
            side="right"
            overlay
          >
            <q-list>
              <q-item
                v-close-popup
                :clickable="discount.isTranslation"
                @click.stop="include('siteActivities', activitySession.activity); includeId('siteActivity', activitySession.activity.id)"
              >
                <q-item-section avatar>
                  <q-icon name="filter_alt" />
                </q-item-section>
                <q-item-section>
                  Include Activity
                </q-item-section>
              </q-item>

              <q-item
                v-close-popup
                :clickable="discount.isTranslation"
                @click.stop="include('siteActivitySessions', activitySession); includeId('siteActivitySession', activitySession.id)"
              >
                <q-item-section avatar>
                  <q-icon name="filter_alt" />
                </q-item-section>
                <q-item-section>
                  Include Activity Session
                </q-item-section>
              </q-item>

              <q-separator />

              <q-item
                v-close-popup
                :clickable="discount.isTranslation"
                @click.stop="exclude('siteActivities', activitySession.activity); excludeId('siteActivity', activitySession.activity.id)"
              >
                <q-item-section avatar>
                  <q-icon name="not_interested" />
                </q-item-section>
                <q-item-section>
                  Exclude Activity
                </q-item-section>
              </q-item>

              <q-item
                v-close-popup
                :clickable="discount.isTranslation"
                @click.stop="exclude('siteActivitySessions', activitySession); excludeId('siteActivitySession', activitySession.id)"
              >
                <q-item-section avatar>
                  <q-icon name="not_interested" />
                </q-item-section>
                <q-item-section>
                  Exclude Activity Session
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-chip>
      </div>
    </div>
    <div v-else-if="discount.type === 'item'">
      <div class="text-h6 q-mb-sm">
        Matching Items ({{ filteredItems.length }})
      </div>
      <div class="row">
        <q-chip
          v-for="item in filteredItems.slice(0, 15)"
          :key="item.id"
          :removable="!discount.isTranslation"
          class="col-auto"
          size="md"
          :label="item.name"
          @remove="excludeId('siteItem', item.id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiscountPreview',
  props: {
    discount: {
      type: Object,
      required: true
    }
  },
  models: {
    showings: {
      movie: 'default',
      variables: {
        period: 'future',
        orderBy: 'time',
        limit: 200
      }
    },
    activitySessions: {
      activity: 'default',
      variables: {
        period: 'future',
        orderBy: 'startTime',
        limit: 200
      }
    }
  },
  configuration: ['items'],
  computed: {
    filteredShowings () {
      return _.filter(this.showings.data, showing => this.discount.isShowingMatch(showing))
    },
    filteredActivitySessions () {
      return _.filter(this.activitySessions.data, activitySession => this.discount.isActivitySessionMatch(activitySession))
    },
    filteredItems () {
      return _.filter(this.activeItems, item => this.discount.isItemOrderItem({ item, itemVariation: item.itemVariations.data[0] }))
    },
    activeItems () {
      return _.filter(this.items.data, 'isUnarchived')
    }
  },
  methods: {
    include (type, model) {
      if (!_.some(this.discount[type].data, { id: model.id })) {
        this.discount[type].add(model)
      }

      this.discount['exclude' + _.startCase(type)] = false
    },
    exclude (type, model) {
      this.discount[type].add(model)
      this.discount['exclude' + _.startCase(type)] = true
    },
    includeId (type, id) {
      if (!_.include(this.discount[type + 'Ids'], id)) {
        this.discount[type + 'Ids'] = [id]
      }
      this.discount['exclude' + _.startCase(type) + 's'] = false
    },
    excludeId (type, id) {
      if (!this.discount['exclude' + _.startCase(type) + 's']) {
        this.discount[type + 'Ids'] = []
      }
      this.discount[type + 'Ids'].push(id)
      this.discount['exclude' + _.startCase(type) + 's'] = true
    }
  }
}

</script>
